const dateHelper = {
    /**
     * Returns 0-based index of the day of the week, starting with monday by default.
     * @param {Date} date
     * @param {string} firstDay
     */
    dayOfWeek: (date, firstDay) => {
        var daysOfWeek = {
            sunday: 0,
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
        };
        firstDay = firstDay || "monday";
        var day = date.getDay() - daysOfWeek[firstDay];
        return (day < 0 ? day + 7 : day);
    },

    isToday: (someDate) => {
        const today = new Date();
        return someDate.getDate() == today.getDate() &&
            someDate.getMonth() == today.getMonth() &&
            someDate.getFullYear() == today.getFullYear();
    }
};

const stringHelper = {
    /**
    * Returns 0-based index of the day of the week, starting with monday by default.
    * @param {string} s
    */
    capitalize: (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }
};

const pagingHelper = {
    getPagingRange: function getPagingRange(current, { min = 1, total = 20, length = 5 } = {}) {
        if (length > total) length = total;

        let start = current - Math.floor(length / 2);
        start = Math.max(start, min);
        start = Math.min(start, min + total - length);

        return Array.from({ length: length }, (el, i) => start + i);
    }
};

const urlHelper = {
    qualifyURL: function qualifyURL (pathOrURL) {
        if (!(new RegExp('^(http(s)?[:]//)', 'i')).test(pathOrURL)) {
            var url = document.baseURI + pathOrURL;
            return url.replace(/(:\/\/)|(\/)+/g, "$1$2");
        }

        return pathOrURL;
    }
};